import clsx from 'clsx';

import { TextBox } from 'component-lib/atoms/text-box/TextBox';

import { Form } from './Form';

export interface InputProps extends React.ComponentProps<'input'> {
  autoFocus?: boolean;
  className?: string;
  disabled?: boolean;
  error?: string;
  /**
   * In case you want to keep the error border but hide the message, e.g. if handled externally
   */
  hideErrorHint?: boolean;
  hint?: React.ReactNode;
  label?: React.ReactNode;
  name?: string;
  placeholder?: string;
  touched?: boolean;
  value?: string;
  type?: string;
  innerRef?: React.Ref<HTMLInputElement>;
  prefixNode?: React.ReactNode;
  suffixNode?: React.ReactNode;
}

export const Input = ({
  autoFocus,
  className,
  disabled,
  error,
  hideErrorHint,
  hint,
  label,
  name,
  onChange,
  placeholder,
  touched,
  type = 'text',
  value,
  innerRef,
  prefixNode,
  suffixNode,
  ...props
}: InputProps) => {
  const hasError = Boolean(touched && error);
  const hintText = hasError && !hideErrorHint && error ? error : hint;

  const control = (
    <TextBox
      {...props}
      hasError={hasError}
      autoFocus={autoFocus}
      disabled={disabled}
      inputRef={innerRef}
      name={name}
      onChange={onChange}
      placeholder={placeholder}
      postfix={suffixNode}
      prefix={prefixNode}
      type={type}
      value={value}
    />
  );

  return (
    <Form.Group className={clsx('leading-loose', className)}>
      {label ? (
        <Form.Label>
          {label}
          {control}
        </Form.Label>
      ) : (
        control
      )}
      {hintText && <Form.Hint error={hasError}>{hintText}</Form.Hint>}
    </Form.Group>
  );
};
